import React from 'react';
import { Routes, Route } from 'react-router-dom';
import EditCustomerContent from './EditCustomerContent';
import CustomerProjects from './CustomerProjects';

const CustomerRoutes = () => {
  return (
    <Routes>
      <Route path="/edit-customer/:id" element={<EditCustomerContent />} />
      <Route path="/customers/:id" element={<EditCustomerContent />} />
      <Route path="/customers/:id/project" element={<EditCustomerContent />} />
      <Route path="/customers/:id/subscription" element={<EditCustomerContent />} />
      <Route path="/customers/:id/project/:projectId" element={<CustomerProjects />} />
      <Route path="/customers/:id/project/:projectId/members" element={<CustomerProjects />} />
      <Route path="/customers/:id/project/:projectId/members/:memberId" element={<CustomerProjects />} />
      <Route path="/customers/:id/project/:projectId/procurements" element={<CustomerProjects />} />
      <Route path="/customers/:id/project/:projectId/procurements/:procurementId" element={<CustomerProjects />} />
      <Route path="*" element={<EditCustomerContent />} />
    </Routes>
  );
};

export default CustomerRoutes;


